import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 rounded-3xl mx-4 md:mx-6 mb-6 mt-20">
      <div className="px-8 md:px-14 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <h3 className="text-2xl font-bold text-white mb-4">每天都有新鲜瓜</h3>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">
              今日大瓜 — 你的每日娱乐资讯伴侣。我们追踪最热八卦，深挖社会热点，让吃瓜变得更有趣、更有料。
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold mb-4">热门频道</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer">
                品牌介绍
              </Link>
              <Link to="/about" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer">
                联系我们
              </Link>
              <Link to="/" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer">
                隐私政策
              </Link>
              <Link to="/" className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer">
                用户协议
              </Link>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-white text-sm font-semibold mb-4">订阅每日瓜报</h4>
            <p className="text-foreground-400 text-sm mb-4">不错过任何一个重磅大瓜，每日精选推送到你手中</p>
            <form
              id="footer-subscribe"
              data-readdy-form
              action="https://readdy.ai/api/form/d913mus6ci2plld1oi90"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="flex flex-col sm:flex-row gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="输入你的邮箱"
                required
                className="flex-1 px-4 py-3 rounded-full bg-white/10 text-white text-sm placeholder:text-foreground-400 border border-white/10 focus:outline-none focus:border-white/30 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="absolute opacity-0 pointer-events-none"
              />
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-950 text-sm font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                订阅
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 px-8 md:px-14 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-foreground-500 text-xs">
          &copy; 2026 今日大瓜 00kkke.cn. All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <a href="#" className="text-foreground-400 hover:text-white transition-colors cursor-pointer" aria-label="微博">
            <i className="ri-weibo-line text-lg"></i>
          </a>
          <a href="#" className="text-foreground-400 hover:text-white transition-colors cursor-pointer" aria-label="微信">
            <i className="ri-wechat-line text-lg"></i>
          </a>
          <a href="#" className="text-foreground-400 hover:text-white transition-colors cursor-pointer" aria-label="抖音">
            <i className="ri-tiktok-line text-lg"></i>
          </a>
        </div>
      </div>

      <div className="px-8 md:px-14 pb-10 select-none pointer-events-none">
        <span className="text-6xl md:text-8xl font-bold text-white/5 tracking-tighter">今日大瓜</span>
      </div>
    </footer>
  );
}

// Helper: just export the form URL for other components
export function getFormUrl() {
  return "https://readdy.ai/api/form/d913mus6ci2plld1oi90";
}
